import { ErrorBase } from '@/errors/ErrorBase';

export class SchoolNotFoundError extends ErrorBase {
    static get defaultMessage(): string {
        return 'ご利用の学校は有効ではないため、ログインすることができません。';
    }

    static get errorName(): string {
        return 'SchoolNotFoundError';
    }
}
